<template>
  <div>
    <el-dialog
      top="3vh"
      width="1000px"
      center
      :close-on-click-modal="false"
      :title="orderDetailTitle"
      :visible="dialogVisible"
      style="margin-bottom: 2vh"
      @close="closeDialog"
      class="order-detail-popup"
    >
      <div class="order-status-layout">
        <div class="order-status-title">订单状态</div>
        <div
          class="order-status"
          v-html="
            HandleOrderStatusClass(
              orderDetail.orderStatus,
              orderDetailDialogObj.order_type
            )
          "
        ></div>
        <el-button
          v-if="['admin', 'switchboard'].indexOf(userInfo.userType) !== -1"
          size="mini"
          style="position: absolute; right: 0; top: 0px"
          plain
          icon="el-icon-chicken"
          @click="
            commonCopyOrderDetailToClipboard(
              orderDetailDialogObj.order_type,
              orderDetail
            );
            closeDialog();
          "
          >复制信息</el-button
        >
      </div>
      <el-descriptions direction="vertical" border :column="6">
        <el-descriptions-item label="平台订单号">
          {{ orderDetail.orderId }}
        </el-descriptions-item>
        <el-descriptions-item label="订单号">
          {{ orderDetail.appOrder }}
        </el-descriptions-item>
        <el-descriptions-item label="应用名称">
          {{ orderDetail.mchCode }}
        </el-descriptions-item>
        <el-descriptions-item label="下单金额">
          {{
            formatNumberWithCommasAndDecimalSeparator(orderDetail.originCost, 2)
          }}
        </el-descriptions-item>
        <el-descriptions-item label="支付金额">
          {{
            formatNumberWithCommasAndDecimalSeparator(
              orderDetail.receiptCost,
              2
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="
            ['admin'].indexOf(userInfo.userType) !== -1 &&
            orderDetail.applyUsernamePath
          "
          label="所属总代"
        >
          <el-tooltip
            effect="dark"
            content="scope.row.username"
            placement="top-start"
            popper-class="username-path-tooltip-class"
          >
            <div
              slot="content"
              v-html="formatUserNamePathTooltip(orderDetail.applyUsernamePath)"
            ></div>
            <div size="mini">
              <template>
                {{
                  orderDetail.applyUsernamePath
                    ? orderDetail.applyUsernamePath.split("/")[1]
                    : ""
                }}
                <i
                  style="cursor: pointer"
                  @click="
                    CopyTextToClipboard(
                      formatPureUserNamePathTooltip(
                        orderDetail.applyUsernamePath
                      )
                    )
                  "
                  class="el-icon-document-copy"
                ></i>
              </template>
            </div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="
            (userInfo &&
              ['admin', 'switchboard', 'agent', 'kefu'].indexOf(
                userInfo.userType
              ) !== -1) ||
            userInfo.roles.indexOf('zhuli') !== -1
          "
          label="实名支付"
        >
          <template v-if="orderDetail.expectedTransPayName">
            <el-tooltip
              class="item"
              effect="dark"
              content="实名订单"
              placement="top-start"
              :disabled="!orderDetail.orderType && orderDetail.orderType !== 1"
            >
              <el-tag
                size="small"
                :type="
                  !orderDetail.orderType && orderDetail.orderType !== 1
                    ? 'success'
                    : 'warning'
                "
                >{{ orderDetail.expectedTransPayName }}</el-tag
              >
            </el-tooltip>
          </template>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-descriptions
        v-if="orderDetailDialogObj.order_type === 'withdraw'"
        direction="vertical"
        :column="
          orderDetail.operatorUsername &&
          ['admin', 'switchboard'].indexOf(userInfo.userType) !== -1
            ? 3
            : 2
        "
        border
      >
        <el-descriptions-item
          label="银行卡信息"
          :content-style="{ width: '40%' }"
        >
          {{ orderDetail.bankName }} {{ orderDetail.bankCardName }}
          {{ orderDetail.bankNo }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="orderDetailDialogObj.order_type === 'withdraw'"
          label="转账目标"
          :content-style="{ width: '40%' }"
        >
          {{ orderDetail.toBankName ? orderDetail.toBankName : "" }}
          {{ orderDetail.toRealName ? orderDetail.toRealName : "" }}
          {{ orderDetail.toBankNo ? orderDetail.toBankNo : "" }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="
            orderDetail.operatorUsername &&
            ['admin', 'switchboard'].indexOf(userInfo.userType) !== -1
          "
          label="操作员用户名"
        >
          <div style="">
            <i class="el-icon-user-solid" />
            {{ orderDetail.operatorUsername }}
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-descriptions direction="vertical" :column="3" border>
        <el-descriptions-item
          :content-style="{ width: '33%' }"
          label="回调状态"
        >
          <el-tag
            size="mini"
            :type="orderDetail.callbackStatus ? 'success' : 'danger'"
          >
            {{ orderDetail.callbackStatus ? "已回调" : "未回调" }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="
            userInfo &&
            ['admin', 'switchboard', 'seller', 'sms_admin'].indexOf(
              userInfo.userType
            ) !== -1
          "
          label="退款状态"
          :content-style="{ width: '33%' }"
        >
          <span
            v-html="translateRefundStatusHTML(orderDetail.refundStatus)"
          ></span>
          <el-button
            v-if="
              userInfo &&
              ['admin', 'switchboard'].indexOf(userInfo.userType) !== -1 &&
              orderDetail.refundStatus === 2 // 退款中
            "
            icon="el-icon-lollipop"
            style="margin-left: 5px"
            size="mini"
            @click="redoOrderRefund()"
            >重作</el-button
          >

          <el-tag
            style="margin-left: 6px"
            size="mini"
            :type="orderDetail.refundCallbackStatus ? 'success' : 'danger'"
          >
            {{ orderDetail.refundCallbackStatus ? "已回调" : "未回调" }}
          </el-tag>
          <el-button
            v-if="
              userInfo &&
              ['admin', 'switchboard'].indexOf(userInfo.userType) !== -1 &&
              (orderDetail.refundStatus === 3 || // 退款完成
                orderDetail.refundStatus === 100) // 直接退款成功
            "
            style="margin-left: 5px"
            size="mini"
            type="success"
            @click="retryRefundCallback()"
          >
            <i class="el-icon-refresh"></i>
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="
            userInfo &&
            ['admin', 'switchboard'].indexOf(userInfo.userType) !== -1 &&
            [0, 1, 4, 5].indexOf(orderDetail.refundStatus) !== -1
          "
          label="退款操作"
          :content-style="{ width: '33%' }"
        >
          <template v-if="orderDetail.refundStatus === 0 && !forceRefundStatus">
            <el-button
              v-if="
                userInfo.userType !== 'switchboard' ||
                orderDetailDialogObj.order_type !== 'withdraw'
              "
              @click="forceRefund()"
              size="mini"
              type="danger"
              >直接退款</el-button
            >
          </template>
          <template
            v-else-if="orderDetail.refundStatus === 0 && forceRefundStatus"
          >
            <el-tag style="margin-left: 6px" size="mini" type="danger">
              直接退款
            </el-tag>
          </template>
          <template
            v-else-if="[1, 4, 5].indexOf(orderDetail.refundStatus) !== -1"
          >
            <el-button
              type="success"
              size="small"
              @click="approveOrRejectRefund('同意')"
              >同意</el-button
            >
            <el-button
              type="warning"
              size="small"
              @click="approveOrRejectRefund('拒绝')"
              >拒绝</el-button
            >
          </template>
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="凭证">
          <!-- 如果不是操作员管理员 -->
          <div v-if="['operator_admin'].indexOf(userInfo.userType) === -1">
            {{
              orderDetail.smsReceipt ? `【短信】${orderDetail.smsReceipt}` : ""
            }}
            {{
              orderDetail.transdetailReceipt
                ? `【银行流水】${orderDetail.transdetailReceipt}`
                : ""
            }}
          </div>
          <!-- 如果是操作员管理员 -->
          {{
            orderDetail.smsReceiptForWithdrawed &&
            ["operator_admin"].indexOf(userInfo.userType) !== -1
              ? `【到帐】${orderDetail.smsReceiptForWithdrawed}`
              : ""
          }}
        </el-descriptions-item>
      </el-descriptions>

      <template
        v-if="
          ['admin', 'switchboard', 'credential_auditor'].indexOf(
            userInfo.userType
          ) !== -1
        "
      >
        <br />
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="辅助决策凭证">
            {{
              orderDetail.referenceSmsReceipt
                ? `${orderDetail.referenceSmsReceipt}`
                : ""
            }}
          </el-descriptions-item>
        </el-descriptions>
      </template>

      <br />
      <el-descriptions
        direction="vertical"
        :column="4"
        :content-style="{ width: '25%' }"
        border
      >
        <el-descriptions-item
          :label="`付款${orderDetail.qrcode ? '二维码' : '银行卡'}`"
        >
          {{ orderDetail.transPayBankNo ? orderDetail.transPayBankNo : "" }}
        </el-descriptions-item>
        <el-descriptions-item label="付款姓名">
          <template
            v-if="
              (['admin', 'switchboard'].indexOf(userInfo.userType) !== -1 ||
                userInfo.roles.indexOf('zhuli') !== -1) &&
              orderDetail.orderStatus === 2
            "
          >
            <el-input
              style="width: 155px"
              size="small"
              v-model.trim="orderDetail.transPayName"
            ></el-input>
            <el-button
              style="margin-left: 5px"
              size="small"
              @click="updatePayOrderReceiptTransPayName()"
              >保存</el-button
            >
          </template>
          <span v-else>{{ orderDetail.transPayName }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="`收款${orderDetail.qrcode ? '二维码' : '银行'}`"
        >
          {{ orderDetail.transPayeeBankNo ? orderDetail.transPayeeBankNo : "" }}
        </el-descriptions-item>
        <el-descriptions-item label="收款姓名">
          {{ orderDetail.transPayeeName ? orderDetail.transPayeeName : "" }}
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="备注" v-if="userInfo.userType === 'admin'">
          {{ orderDetail.remark }}
          <router-link
            v-if="
              orderDetail.remark &&
              orderDetail.remark.indexOf('转账退回') !== -1
            "
            target="_blank"
            :to="{
              path: '/certificate/certificatePay',
              query: { orderId: orderDetail.id },
            }"
          >
            <el-button style="margin-left: 5px" size="mini">
              关联凭证
            </el-button>
          </router-link>
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-descriptions
        direction="vertical"
        :column="3"
        border
        :content-style="{ width: '33%' }"
      >
        <el-descriptions-item label="创建时间">
          {{ orderDetail.createdTime }}
        </el-descriptions-item>
        <el-descriptions-item
          label="收款时间"
          v-if="orderDetailDialogObj.order_type === 'pay'"
        >
          {{ orderDetail.payedTime }}
        </el-descriptions-item>
        <el-descriptions-item
          label="付款时间"
          v-else-if="orderDetailDialogObj.order_type === 'withdraw'"
        >
          {{ orderDetail.withdrawedTime }}
        </el-descriptions-item>
        <el-descriptions-item label="回调时间">
          {{ orderDetail.finishTime }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import {
  getPayOrderDetailList, // 获取支付订单详情列表
  getQRCodePayOrderDetailList, // 获取二维码支付订单详情列表
  getWithdrawOrderDetailList, // 获取提现订单详情列表
  approveOrRejectPayOrderRefund, // 同意或拒绝支付退款
  approveOrRejectWithdrawOrderRefund, // 同意或拒绝提现退款
  enforcePayOrderRefund, // 支付订单直接退款
  enforceWithdrawOrderRefund, // 提现订单直接退款
  reTryRefundCallback, // 订单退款回调
  getListAllOperatorWithdrawOrders, // 获取提现订单详情列表 for operator_admin
  redoPayOrderRefund, // 重做支付订单退款
  redoWithdrawOrderRefund, // 重做提现订单退款
  updatePayOrderReceiptTransPayName, // 更新支付订单凭证付款人姓名
} from "@/api/order";
import varCommon from "@/utils/varCommon";

/*
  监听资料变动，并有传值的时候获取列表
  成功获取列表才打开弹窗
  关闭时 emit 把监听的资料改为 null
*/
export default {
  mixins: [mainCommon],
  components: {},
  props: {
    orderDetailDialogObj: {
      type: Object,
      default: function () {
        return {
          order_type: "", // pay or withdraw
          id: null,
        };
      },
    },
  },
  watch: {
    orderDetailDialogObj: {
      handler: function (newVal) {
        // 关闭的时候会把 id 改回 null，这时候不需要触发查订单
        if (newVal.id) {
          if (newVal.order_type === "pay") {
            this.getPayOrderDetailList();
          } else if (newVal.order_type === "withdraw") {
            this.getWithdrawOrderDetailList();
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      orderDetail: {},
      forceRefundStatus: false,
      streamOrderFixingDialog: {},
    };
  },
  computed: {
    orderDetailTitle() {
      let returnTitle = "";
      if (["seller"].indexOf(this.userInfo.userType) !== -1) {
        returnTitle +=
          this.orderDetailDialogObj.order_type === "pay" ? "支付" : "提现";
      } else {
        returnTitle +=
          this.orderDetailDialogObj.order_type === "pay" ? "收款" : "付款";
      }
      returnTitle += `「${this.orderDetail.orderId}」的订单详情 ( ${this.orderDetail.id} ) `;
      return returnTitle;
    },
  },
  methods: {
    // 更新支付订单凭证付款人姓名
    updatePayOrderReceiptTransPayName() {
      updatePayOrderReceiptTransPayName(this.orderDetail.id, {
        transPayName: this.orderDetail.transPayName,
      }).then(() => {
        this.$notify.success(this.orderDetail.transPayName + " 保存成功");
        this.$emit("HandleGetList");
      });
    },
    retryRefundCallback() {
      reTryRefundCallback({
        orderType: this.orderDetailDialogObj.order_type === "pay" ? 0 : 1, // PAY(0, "支付订单"), WITHDRAW(1, "提现订单")
        orderId: this.orderDetail.id,
      }).then(() => {
        this.$notify.success(
          `${this.orderDetail.orderId} 操作完成，异步回调中，请稍等片刻后再刷新`
        );
      });
    },
    // 重作
    redoOrderRefund() {
      if (this.orderDetailDialogObj.order_type === "pay") {
        redoPayOrderRefund(this.orderDetailDialogObj.id).then(() => {
          this.$notify.success("操作成功");
        });
      } else if (this.orderDetailDialogObj.order_type === "withdraw") {
        redoWithdrawOrderRefund(this.orderDetailDialogObj.id).then(() => {
          this.$notify.success("操作成功");
        });
      }
    },
    // Pay
    getPayOrderDetailList() {
      if (
        this.orderDetailDialogObj.accType &&
        this.orderDetailDialogObj.accType !== "bank"
      ) {
        getQRCodePayOrderDetailList({
          id: this.orderDetailDialogObj.id,
        })
          .then((res) => {
            this.writeDataToList(res);
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.dialogVisible = false;
          });
      } else {
        getPayOrderDetailList({
          id: this.orderDetailDialogObj.id,
        })
          .then((res) => {
            this.writeDataToList(res);
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.dialogVisible = false;
          });
      }
    },
    // Withdraw
    getWithdrawOrderDetailList() {
      if (this.userInfo.userType === "operator_admin") {
        getListAllOperatorWithdrawOrders({
          id: this.orderDetailDialogObj.id,
        })
          .then((res) => {
            this.writeDataToList(res);
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.dialogVisible = false;
          });
      } else {
        getWithdrawOrderDetailList({
          id: this.orderDetailDialogObj.id,
        })
          .then((res) => {
            this.writeDataToList(res);
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.dialogVisible = false;
          });
      }
    },
    // 写资料
    writeDataToList(res) {
      if (res.data && res.data.list.length > 0) {
        this.orderDetail = res.data.list[0]; // 显示第一笔资料

        this.dialogVisible = true; // 当有资料时可以显示弹窗
      } else {
        this.$notify.error("无资料");
        this.dialogVisible = false;
      }
    },
    closeDialog() {
      this.$emit("close");
      this.dialogVisible = false;
      this.forceRefundStatus = false;
    },
    // 同意或是拒绝退款
    approveOrRejectRefund(operation) {
      if (!operation) return;
      this.$confirm(`${operation}退款`, "退款操作", {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: operation === "同意" ? "success" : "warning",
      })
        .then(() => {
          if (this.orderDetailDialogObj.order_type === "pay") {
            approveOrRejectPayOrderRefund(this.orderDetailDialogObj.id, {
              isApprove: operation === "同意" ? true : false,
            })
              .then(() => {
                this.$notify.success("操作成功");
                // 协助关闭视窗
                this.closeDialog();
              })
              .catch(() => {
                this.$notify.error("请稍后再试");
              });
          } else if (this.orderDetailDialogObj.order_type === "withdraw") {
            approveOrRejectWithdrawOrderRefund(this.orderDetailDialogObj.id, {
              isApprove: operation === "同意" ? true : false,
            })
              .then(() => {
                this.$notify.success("操作成功");
                // 协助关闭视窗
                this.closeDialog();
              })
              .catch(() => {
                this.$notify.error("请稍后再试");
              });
          }
        })
        .catch(() => {});
    },
    // 直接退款
    forceRefund() {
      this.$confirm("确定直接退款？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "error",
      })
        .then(() => {
          if (this.orderDetailDialogObj.order_type === "pay") {
            enforcePayOrderRefund(this.orderDetailDialogObj.id).then(() => {
              this.forceRefundStatus = true;
              this.$notify.success("操作成功");
              // 协助关闭视窗
              this.closeDialog();
            });
          } else if (this.orderDetailDialogObj.order_type === "withdraw") {
            enforceWithdrawOrderRefund(this.orderDetailDialogObj.id).then(
              () => {
                this.forceRefundStatus = true;
                this.$notify.success("操作成功");
                // 协助关闭视窗
                this.closeDialog();
              }
            );
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.order-detail-popup /deep/ .el-dialog--center .el-dialog__body {
  padding: 0 25px 30px;
}
.order-status-layout {
  position: relative;
  text-align: center;
  font-weight: 500;
}
.order-status-title {
  position: absolute;
  left: 0;
  font-size: 17px;
  margin: 0;
}
.order-status {
  font-size: 20px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/dialog/OrderDetail.vue